<template>
  <div>
    <el-dialog title="释放子订单" :visible.sync="customShow" width="630px"
               :before-close="clearOrder"        custom-class="release-orders-container default-table"
               center>
      <div class="main">
        <div class="info">
          <div class="order-no" style="min-width: 96px;">
            <div><h3>{{ order.order_no }}</h3></div>
          </div>
          <div class="no"><span>合同编号：</span><span>{{ order.contract_no || '-' }}</span></div>
          <div><span>客户：</span><span>{{ order.customer_name || '-' }}</span></div>
          <div><span>订单编号：</span><span>{{ order.order_no || '-' }}</span></div>
          <div><span>销售：</span><span>{{ order.sale_name || '-' }}</span></div>
          <div><span>产品名称：</span><span>{{ order.product || '-' }}</span></div>
          <div><span>含税收入：</span><span>{{ order.payment_account || '-' }}</span></div>
          <div><span>建单时间：</span><span>{{ order.created_at || '-' }}</span></div>
        </div>
      </div>
      <br/>
      <el-alert title="确认释放后，将会重置归档信息、影响普客营销项目发票状态、回款状态，请仔细核对。" type="info" center
                :closable="false"/>
      <el-select class="form-coop" v-model="form_of_cooperation"
                 :placeholder="`请为 ${order.order_no} 选择新的合作形式`">
        <el-option
            v-for="item in optionsForm"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="disabledCooperation(item.value)"
        >
        </el-option>
      </el-select>

      <div class="dialog-footer" style="text-align: center;">
        <el-button @click="clearOrder" size="mini">取 消</el-button>
        <el-button type="primary" @click="handelSubmit" size="mini">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getOptionItems} from "@/api/option";
import {releasePukeOrderChild} from "@/api/regulars";

export default {
  name: "ReleasePukeChildOrders",
  components: {},
  props: {
    show: {
      type: Boolean,
      default() {
        return false;
      }
    },
    project: {
      type: [Object, Boolean],
      required: true
    },
    order: { //当前项目
      type: [Object, Boolean],
      required: true
    }
  },
  data() {
    return {
      customShow: false,
      form_of_cooperation: null,
      optionsForm: [],
    }
  },
  watch: {
    show: function (v) {
      if (v) {
        this.customShow = this.show
      }
    },
    customShow: function (v) {
      this.$emit('update:show', v)
    },

  },
  mounted() {
    this.getOptions()
  },
  methods: {
    /**
     * 提交
     * @returns {Promise<void>}
     */
    async handelSubmit() {
      const that = this
      if (!that.form_of_cooperation) {
        that.$message.warning('请选择新的合作形式！')
        return;
      }
      const params = {
        project_no: this.project.order_no,
        order_no: this.order.order_no,
        form_of_cooperation: this.form_of_cooperation,
      }
      const response = await releasePukeOrderChild(params)
      if (!response.success) {
        that.showToast({h: that, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }
      this.showToast({h: that, icon: "el-icon-success", text: '操作成功', duration: 2000});
      that.clearOrder()
      this.$emit('success')
    },
    getOptions() {
      getOptionItems(['form_of_cooperation']).then(res => {
        let {form_of_cooperation} = res.model;
        const focOptions = []
        if (form_of_cooperation) {
          Object.keys(form_of_cooperation).forEach((k) => {
            focOptions.push({label: form_of_cooperation[k], value: k})
          })
        }
        this.optionsForm = focOptions;
      })
    },
    disabledCooperation(value) {
      const array = ['红人全案', '普客打包']
      return array.indexOf(value) !== -1;
    },
    clearOrder(){
      this.$emit('clearOrder',true)
      this.customShow=false
    }
  }
}
</script>

<style lang="scss">
.release-orders-container {
  font-family: DINPro-Medium, DINPro Medium, sans-serif;
  //height: 100%;

  .el-dialog__body {
    //height: calc(100% - 110px);
  }

  .flex {
    display: flex;
  }

  .main {
    .info {
      div {
        font-size: 14px;
        color: #8a8e99;
        line-height: 20px;

        span:first-child {
          margin-right: 12px;
          width: 80px;
          display: inline-block;
        }

        span:last-child {
          color: rgba(0, 0, 0, 0.85);
        }
      }

    }

    .order-no {
      height: 22px;
      background: #fafbff;
      border: 1px solid #f5f6fa;
      border-radius: 12px;
      padding: 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      font-weight: 700;
      color: #45474d;
      font-variant: tabular-nums;
    }
  }

  .form-coop {
    width: 60%;
    display: block;
    margin: 20px auto;
  }
}
</style>
